import { Container, Divider } from '@material-ui/core';
import React from 'react';
import { useBreakpoints } from 'utils/use-breakpoints';
import BackToDashboard from '../shared/back-to-dashboard';
import { CatalogueBar } from './catalogue-bar/catalogue-bar';
import { CatalogueWrapperProps } from './catalogue-wrapper-props';
import './catalogue.scss';

/**
 * Wraps a Sale or Semen catalogue root component.
 *
 * Note: This is not treated as the base `catalogue` route component.
 * @param props
 */
export const CatalogueWrapper: React.FC<CatalogueWrapperProps> = (props) => {
  const {
    catalogue,
    resultsCount,
    totalCount,
  } = props;
  const { phone } = useBreakpoints();

  return (
    <>
      <BackToDashboard />
      <CatalogueBar title={props.catalogue} />
      <div className="sg-catalogues">
        <Container className="sg-catalogues__info">
          <div className="info-container container-padding">
            <h3>Current sales</h3>
            {!!totalCount && (
              <h4>Viewing {resultsCount} of {totalCount} <span className="sg-catalogues__info-type">{catalogue}</span></h4>
            )}
          </div>
          {!phone && (<Divider variant="fullWidth" />)}
        </Container>
        <Container className={`sg-catalogues__content ${props.className}`}>
          {props.children}
        </Container>
      </div>
    </>
  );
};
